import { WppSkeleton } from '@wppopen/components-library-react'
import TypographySkeleton from './TypographySkeleton'

interface FilterSkeletonProps {
  width?: number
}

const FilterSkeleton = ({ width }: FilterSkeletonProps) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start', width }}>
      <TypographySkeleton type="s-strong" width={75} />
      <WppSkeleton variant="rectangle" style={{ width: '100%' }} height={40} data-testid="filter-item-skeleton" />
    </div>
  )
}

export default FilterSkeleton
